import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ElectricalPage from "./pages/ElectricalPage";
import SecurityPage from "./pages/SecurityPage";
import IndustriesPage from "./pages/IndustriesPage";
import ContactPage from "./pages/ContactPage";
import QuotePage from "./pages/QuotePage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/what-we-do" element={<ServicesPage />} />
            <Route path="/services/electrical" element={<ElectricalPage />} />
            <Route path="/services/security" element={<SecurityPage />} />
            <Route path="/what-we-do/electrical" element={<ElectricalPage />} />
            <Route path="/what-we-do/security" element={<SecurityPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/get-a-quote" element={<QuotePage />} />
            <Route path="/quote" element={<QuotePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
